export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "codec.worker.0f06baf840f457e3d8c8.worker.js");
}
